<!-- backups -->
<app-backup-list></app-backup-list>

<!-- read current values button -->
<div class="read-vdds-btn-container flex flex-row justify-start items-center">
  <button
    class="read-vdds-btn"
    [disabled]="
      !isActiveSessionAvailable ||
      !(remoteDiagnosticsSnapshotsStore.installationVddListLength$ | async)
    "
    mat-stroked-button
    gtm="onStart"
    gtmAction="read current vdd values"
    gtmCategory="vddBackups"
    color="primary"
    (click)="readCurrentValues()"
  >
    <mat-icon class="icon">chrome_reader_mode</mat-icon
    >{{ '+REMOTE_DIAGNOSTICS_BACKUPS.READ_CURRENT_VALUES_BTN.TEXT' | translate }}
  </button>
</div>

<app-backup-loader></app-backup-loader>

<!-- connection failed text -->
<div
  class="flex flex-row justify-center items-center"
  *ngIf="
    (remoteDiagnosticsStore.getActiveConnectionStep$ | async) ===
      diagnosticsModalStep.CONNECTION_FAILED &&
    !(remoteDiagnosticsSnapshotsStore.showFetchSnapshotDetailsLoader$ | async) &&
    !(remoteDiagnosticsSnapshotsStore.showValues$ | async)
  "
>
  {{ '+REMOTE_DIAGNOSTICS_BACKUPS.CONNECTION_FAILED_MESSAGE' | translate }}
</div>

<!-- loader (fetch backup details) -->
<div
  class="loader flex flex-col justify-center items-center"
  *ngIf="remoteDiagnosticsSnapshotsStore.showFetchSnapshotDetailsLoader$ | async; else hideLoader"
>
  <div class="fetching-backup-loader flex flex-col justify-center items-center">
    <mat-icon class="loop">loop</mat-icon>
    <div class="flex flex-col justify-around items-center">
      <p>{{ '+REMOTE_DIAGNOSTICS_BACKUPS.FETCHING_BACKUP_DETAILS_LOADER_TEXT' | translate }}</p>
    </div>
  </div>
</div>

<ng-template #hideLoader>
  <ng-container *ngIf="remoteDiagnosticsSnapshotsStore.showValues$ | async">
    <!-- loader (generate backup) -->
    <div
      class="flex flex-col justify-start items-start"
      *ngrxLet="remoteDiagnosticsSnapshotsStore.showCreateSnapshotLoader$ as loader"
    >
      <ng-template [ngIf]="loader" [ngIfElse]="showGenerateBackupButton">
        <div class="flex flex-col justify-center items-center">
          <vi-loader
            [isLoading]="true"
            message="{{ '+REMOTE_DIAGNOSTICS_BACKUPS.LOADER.SAVING_BACKUP_TEXT' | translate }}"
          ></vi-loader>
        </div>
      </ng-template>

      <ng-template #showGenerateBackupButton>
        <ng-container *ngIf="!(remoteDiagnosticsSnapshotsStore.isSnapshotCreated$ | async)">
          <button
            *ngIf="remoteDiagnosticsSnapshotsStore.getDateOfTheValuesRead$ | async"
            gtm="onStart"
            gtmAction="generate backup"
            gtmCategory="vddBackups"
            mat-raised-button
            color="primary"
            (click)="generateBackup()"
          >
            <mat-icon class="icon">add</mat-icon
            >{{ '+REMOTE_DIAGNOSTICS_BACKUPS.BTN.GENERATE_BACKUP' | translate }}
          </button>
        </ng-container>
      </ng-template>
    </div>
    <app-backup-vdd-table
      [snapshotType]="snapshotType.BACKUP"
      [vdds]="remoteDiagnosticsSnapshotsStore.getInstallationVddListWithoutSeparator$ | async"
    ></app-backup-vdd-table>
  </ng-container>
</ng-template>
